
import { Component, Vue, Watch } from 'vue-property-decorator';
@Component
export default class SearchBar extends Vue {
  @Watch('$route', { immediate: true, deep: true })
  onChange() {
    this.inputFocus();
  }
  value = '';
  @Watch('value')
  onValueChange(newVal: any) {
    if (newVal.length === 0) {
      this.clearValue();
    }
  }
  searchValue() {
    this.$emit('searchValue', this.value);
  }
  clearValue() {
    this.value = '';
    this.$emit('clearValue');
  }
  inputFocus() {
    this.$nextTick(() => {
      const input = this.$refs.searchBar as HTMLElement;
      input.focus();
    });
  }
  mounted() {
    this.inputFocus();
  }
}
